import React, { useEffect, useState } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { getComments, createComment } from "../../redux/actions/user_actions";
import Swal from 'sweetalert2';
import CommentsBlock from 'simple-react-comments';

const Comment = ({ ...props }) => {
  const history = useHistory()
  let userInfo = JSON.parse(localStorage.getItem("user"))
  const id = window.location.pathname.split("/").pop();

  const [comments, setComments] = useState([])
  const [quantity, setQuantity] = useState(comments.length)

  useEffect(() => {    
    props.dispatch(getComments(id)).then(res => {
        if(res.payload) { 
            if(res.payload.comments.length > 0) {
                setComments(res.payload.comments)
            }
            else {
                setComments([{
                    avatarUrl: 'https://firebasestorage.googleapis.com/v0/b/tconcept-e8cbc.appspot.com/o/avatar.png?alt=media&token=eec6fbe1-45a6-4240-9e2a-ab808c204ec2',
                    createdAt: new Date(),
                    fullName: props.templates.templates.templateProperties.store_name,
                    text: 'Hãy để lại bình luận của bạn tại đây!'
                }])
            }
        }
    })
  }, [quantity, id])
  if(props.user.comments && props.user.comments.comments) {
    return (
        <>
            <h4 className="text-center m-0"><b style={{ fontWeight: "bold" }}>Bình Luận</b></h4>
            <hr className="divider" />
            <CommentsBlock
                comments={comments}
                signinUrl={'/login'}
                isLoggedIn={userInfo ? true : false}
                styles={{
                    btn: base => ({
                        ...base,
                        background: props.templates.templates.templateProperties.background_comment_button,
                        '&:hover': {
                            background: props.templates.templates.templateProperties.background_comment_button_hover
                        }
                    }),
                    comment: base => ({
                        ...base,
                        background: props.templates.templates.templateProperties.background_per_comment,
                        padding: 5,
                        borderRadius: 10,
                        margin: '1% auto',
                    }),
                }}
                onSubmit={text => {
                    if (text.length > 0) {
                        let commentSubmit =  {
                            avatarUrl: 'https://firebasestorage.googleapis.com/v0/b/tconcept-e8cbc.appspot.com/o/avatar.png?alt=media&token=eec6fbe1-45a6-4240-9e2a-ab808c204ec2',
                            createdAt: new Date(),
                            fullName: userInfo.customerName,
                            text: text
                        }                    
                        //Create Comment
                        let dataToSubmit = {
                            customerId: userInfo.customerId,
                            productId: id,
                            content: commentSubmit.text
                        }
                        props.dispatch(createComment(dataToSubmit)).then(res => {
                            if(res.payload) {
                                if(res.payload.result.success) {
                                    //Update State
                                    let newComments = comments
                                    newComments.push(commentSubmit)
                                    setComments(newComments)
                                    setQuantity(newComments.length)
                                }
                            }
                            else {
                                return(
                                    Swal.fire({
                                    title: 'Phiên đăng nhập đã hết hạn!',
                                    text: 'Vui lòng đăng nhập lại',
                                    icon: 'warning',
                                    confirmButtonText: 'Đóng',
                                    confirmButtonColor: '#000000',
                                    }
                                    ).then((ok) => {
                                        if(ok) {
                                        window.scrollTo(0, 0)
                                        history.push("/login")
                                        localStorage.removeItem("user")
                                        }
                                    })   
                                )        
                            }
                        })
                    }
                }}
            />
        </>
    );
  }
  return (null);
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Comment);